import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import mapboxgl from "mapbox-gl";
import SingleStore from "../Store/SingleStore";
// import { stores } from "../../utils/StoreData";
import SingleStoreForSmallScreen from "../Store/SingleStoreForSmallScreen";
import Home from "../Home/Home";
import { GlobalContext } from "../../GlobalProvider";
import { fetchHotelDetails, fetchStores } from "../../ServerCall";
import useInfiniteScroll from "../common/useInfiniteScroll";

import { useLocation, useNavigate } from 'react-router-dom';
import LoadingBar from "../common/Loader/LoadingBar";
import NoData from "../common/NoData";
import FilledStar from '../commonAssests/FilledStar.svg'
import CircularCheck from '../commonAssests/CircularCheck.svg'
import { calculateDistance, closeIcon, commonFetchData, directionIcon, getCustomMarker, getDirectionUrl, getStarForPopup, phoneIcon, updateQueryParams } from "../../utils/commanFunctions";
import NewStoreCard from "../common/NewStoreCard";
import SmallPlaceOrEventCard from "./SmallPlaceOrEventCard";
import FullScreenLoader from "./FullSLoader";
import NewFilter from "../common/Filters/NewFilter";
import { Header } from "../common/Header";

import 'mapbox-gl/dist/mapbox-gl.css';
import { ViewButton } from "../common/Buttons/ViewButton";
import SingleCardNew from "../common/SingleCardNew";
import configs from "../../contentConfig";

const setDataUtil = (placesResponse=[])=>{
    if(placesResponse.length>0){
      const data = []
      placesResponse.forEach((e)=>data.push(...e?.event_or_place_list))
      return data
    }
    else 
    return []
}

const Store = () => {
  const [selectedFilter, setSelectedFilter] = useState({
    "display_value": "All",
    "query_value": "all"
  });
  const [isLoading, setIsLoading] = useState(true);
  const [selectedLocation,setSelectedLocation] = useState(null)
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // const apiParams = searchParams.get('apiParams') 
  const apiParams = searchParams.get('apiParams') ||localStorage.getItem('apiParams') 
  const mapContainer = useRef(null);
  const map = useRef(null);
  let navigate = useNavigate();
  const { stores, setStores, hotelData, setHotelData, fetchNextStore,filter,init ,setPreserveData} =
    useContext(GlobalContext);
  // const [page, setPage] = useState(2);
  const smallScreenDiv = useInfiniteScroll(fetchNextStore, "horizontal");
  const LargeScreenDiv = useInfiniteScroll(fetchNextStore, "vertical");
  let id = searchParams.get("id")

  useEffect(() => {
    const appData = JSON.parse(localStorage.getItem("appData"));
    const preservedData = JSON.parse(localStorage.getItem("preservedData"));

    // if (filter && filter === "Personalized") {
    //   if (appData && appData.allPlaceAndEvent && Array.isArray(appData.allPlaceAndEvent)) {
    //     setStores(appData.allPlaceAndEvent);
    //   } else if (preservedData) {
    //    setPreserveData()
    //   } else {
    //     init(null,"Map");
    //   }
    // } else {
      
    //   init(null,"Map");
    // }

    // init(null,"Map");

    const fetchData = async () => {
      try {
        // setIsLoading(true);
        const [placesResponse] = await Promise.all([
          commonFetchData(`/planner/places-events/groups/${apiParams?"?"+apiParams:""}`, {req:"get", onErrorData:[]}),
        ]);

     setStores(setDataUtil(placesResponse))
      } catch (error) {
        console.error("Data fetching error:", error);
        // setNoData(true);
      } finally {
        // setIsLoading(false);
      }
    };

    // fetchData();



    (async () => {
      const fetchedHotelData = await fetchHotelDetails();
      if (fetchedHotelData.status) {
        setHotelData(fetchedHotelData.data);
      } else {
        console.log(fetchedHotelData);
      }
    })();

    if (map.current) return;
    mapboxgl.accessToken =
     process.env.REACT_APP_MAPBOX_API_KEY;

    const mapPageConfig = configs?.MapPage || {};
    const validLocations = stores.filter(
      (loc) => loc.longitude != null && loc.latitude != null
    );
    const initialCenter = mapPageConfig.center ||
      (validLocations.length > 0
        ? [validLocations[0].longitude, validLocations[0].latitude]
        : [0, 0]);

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/innspiremapbox/clv9b4wyu00p801ph33xi424i',
      // center: [-77.034084142948, 38.909671288923],
      //  center: [Number(hotelData?.longitude) || 82.60000000, Number(hotelData?.latitude) || 22.50000000],
      center: initialCenter,
      zoom: 13,
      scrollZoom: true,
      ...mapPageConfig,
    });
    map.current.on("load", () => {
      map.current.addSource("places", {
        type: "geojson",
        data: stores,
      });

      // map.current.addControl(
      //   new window.MapboxGeocoder({
      //   accessToken: mapboxgl.accessToken,
      //   mapboxgl: mapboxgl
      //   })
      //   );

      // buildLocationList(stores);
    });
  }, []);

  useEffect(() => {
    if (map.current) {
      addMarkers();
      // createHotelDetails(hotelData)
    }
  }, [stores]);


useEffect(()=>{
 
(async()=>{
if(id){
let res = await fetchStores(null,null,null,id)
if(res.status){
let data = res.data
createShowOnMap(data)
searchParams.delete("id");
const newUrl = `${location.pathname}?${searchParams.toString()}`;
window.history.replaceState(null, '', newUrl);
id=null
}else{
  console.log(res)
}
}else{
  if (map.current && Object.keys(hotelData).length > 0) {
    createHotelDetails(hotelData,true)
}
}
})()
},[id,hotelData])


const handleLocChange = (d)=>{
  if(!d) return
  const obj = stores.find((e)=>e.id===d.id)
  if(obj)setSelectedLocation(obj)
}

const handleCloseLoc = ()=>setSelectedLocation(null)

  const createHotelDetails = (marker={},isHotel=false,fly=true)=>{
    if (marker.longitude && marker.latitude){
      if(isHotel){
        let images = marker.photo? [{
          id:1,
          image:marker.photo
        }]: [
          {
            id:1,
            image:"https://th.bing.com/th/id/OIP.vg49Rg4lf-bVtcQjHxlJkgHaHa?rs=1&pid=ImgDetMain"
          }
        ]       
         let amenities = (marker.amenities && marker.amenities.length>0 ) ? marker.amenities :  marker.category? [marker.category]:[]
        marker = {
          ...marker,amenities,images
        }
      }

      // marker creating ...........
      let existingMarker = document.getElementById(`marker-${marker.id}`)
      if(existingMarker)
      existingMarker.remove()
    const el = document.createElement("img");
    el.id = `marker-${marker.id}`;
    //   "https://www.pngall.com/wp-content/uploads/2017/05/Map-Marker-PNG-File.png"

 if(isHotel){
  el.src = marker?.photo ? marker.photo : getCustomMarker(localStorage.getItem('primaryColor')?`#${localStorage.getItem('primaryColor')}`:"#080808")
  el.style.width = "40px";
 }else{
  el.src = marker.images && marker.images.length > 0 ? marker.images[0].image :  getCustomMarker(`red`)
  el.style.width = "25px";
 }

    el.classList = "ellipse"
    new mapboxgl.Marker(el, { offset: [0, -23] })
    .setLngLat([marker.longitude, marker.latitude])
    .addTo(map.current);
    el.addEventListener("click",  (e) => {
      flyToStore(marker);
      //  createPopUp(marker,true);
    });
// marker createing end .....

if(fly){
  map?.current?.flyTo({
    center: [Number(marker?.longitude), Number(marker?.latitude)],
    zoom: 13,
  });
  // createPopUp(marker,true);
}


    }
  }

  const createShowOnMap = (marker={},isHotel=false)=>{
    if (marker.longitude && marker.latitude){
// marker creating ...........
      let existingMarker = document.getElementById(`marker-${marker.id}`)
      if(existingMarker)
      existingMarker.remove()
    const el = document.createElement("img");
    el.id = `marker-${marker.id}`;
    //   "https://www.pngall.com/wp-content/uploads/2017/05/Map-Marker-PNG-File.png"

  el.src =marker.images && marker.images.length > 0 ? marker.images[0].image : getCustomMarker(`red`)
  el.style.width = "25px";
    el.classList = "ellipse"
 
    new mapboxgl.Marker(el, { offset: [0, -23] })
    .setLngLat([marker.longitude, marker.latitude])
    .addTo(map.current);
el.addEventListener("click", (e) => {
  flyToStore(marker);
   createPopUp(marker);
});
// marker createing end .....
map?.current?.flyTo({
  center: [Number(marker?.longitude), Number(marker?.latitude)],
  zoom: 13,
});
// createPopUp(marker);
createHotelDetails(hotelData,true,false)

    }
  }


  const calculateParallelDistance = (id,parameter)=>{
    calculateDistance(parameter,"miles",hotelData).then((d)=>{
      if(d.status){
       let ele =  document.getElementById(id)
       if(ele)
       ele.innerText = d.data
      }
    })
  }


  const createPopUpHtml = (data,isHotel) => {
    
    const altImag = `https://th.bing.com/th/id/OIP.vg49Rg4lf-bVtcQjHxlJkgHaHa?rs=1&pid=ImgDetMain`
    let html = '';
    let distanceId  = `distanc-${data.id}`
    if(data.latitude && data.longitude && !isHotel)
    calculateParallelDistance(distanceId,[data.latitude,data.longitude])



    // Create the img element
    // html += `<div class="imgage"><img class="w-[100%] h-[15vh] md:h-[20vh]" src="${data.images && data.images.length > 0? data.images[0]:altImag}" alt=""></div>`;

    let imgageDiv = document.createElement("div")
    imgageDiv.classList = "imgage"
    let image = document.createElement("img")
    image.src = data.images && data.images.length > 0? data.images[0]?.image:altImag
    image.classList = "w-[100%] h-[15vh] md:h-[20vh]"
    // skeleton
    if(hotelData.id !== data.id)
    image.onclick = (e)=>{
     e.preventDefault();
     const path =  updateQueryParams({
      path:"description",
      ID : data.id
    })
      navigate(path);
   }
    imgageDiv.appendChild(image)
    const crossIcon = document.createElement("img")
    crossIcon.src = closeIcon("red")
    crossIcon.classList = 'absolute top-[10px] right-[10px] w-[20px] cursor-pointer'
    imgageDiv.appendChild(crossIcon)
    crossIcon.onclick = (e)=>{
      e.preventDefault();
      const popUps = document.getElementsByClassName("mapboxgl-popup");
      if (popUps[0]) popUps[0].remove();
    }

    // Create the content div
    html += `<div class="content bg-white w-[100%] p-3 md:p-5">`;

    // Title
    html += `<div class="one w-[100%]  flex items-start justify-between mb-4"> <span class="text-base md:text-1xl max-w-[75%] font-bold">${data.name}</span>
    <div class="buttons flex items-center justify-center gap-4">
     <span>
     ${
      data?.name?`  <a href="${getDirectionUrl(data.name)}" style="text-decoration:none border:none" target="_blank">
      <img src="${directionIcon()}" alt="" class="w-[20px]"/>
      </a>`:``
    }
    
     </span>
     <span>
  ${
    data?.phone_number?`   <a href="tel:${data?.phone_number}" >
    <img src="${phoneIcon()}" alt="" class="w-[18px]"/>
    </a>`:``
  }
     </span>
    </div></div>`;

    // Address
    // html += `<div class="three mb-2"><p class="text-md md:text-lg font-medium">${data.address}</p></div>`;


  // star 
  html +=`   <div class="mb-2 flex items-center justify-start gap-3">
${data.rating?`  <div class="flex items-center justify-start gap-1">
<span class="text-gray-600 font-medium text-sm md:text-md mt-[0.2rem]">${data.rating}</span> 
    <div class="flex items-center justify-center gap-1">
    ${getStarForPopup(data.rating)}
    </div>
    </div>
        <span class="text-gray-600 font-medium text-sm md:text-lg">(${data?.reviews_count})</span>`:""}
    ${!isHotel?`      <div class="flex items-center justify-center gap-1">
            <img src="${getCustomMarker("green")}" alt="" class="w-[13px]" />
            <span id="${distanceId}" class="text-gray-600 font-medium text-sm md:text-lg min-w-[55px] text-center">--</span>
          </div>`:``}
          </div>
      `

    // tags 
    
    let tagCount = window.innerWidth>700?2:2
    let arr = []  

    if(data.amenities && data.amenities.length>0)
    arr = data.amenities 
  else if (data?.category)
  arr = [data.category?.display_name]

if(arr.length>0)
{
  html += `<div class="two flex items-center justify-start gap-2 flex-wrap">`
  arr = arr.slice(0,tagCount)
  let tags =""
  for(let i of arr){
     tags += `<div class="flex items-center justify-start gap-1">
    <img src="${CircularCheck}" alt="" />
    <span class="text-gray-600 font-medium text-md md:text-lg">${i}</span>
</div>`
  }
 html += tags

  html += `</div>`

  // Close content div
  html += `</div>`;
}

    const mainContainer = document.createElement("div");
    mainContainer.style.fontFamily = "MyFont"
    mainContainer.classList = "popup-dimension"
mainContainer.appendChild(imgageDiv)
mainContainer.insertAdjacentHTML("beforeend",html)
    return mainContainer
};





  function flyToStore(currentFeature) {
    if (Object.keys(currentFeature).length > 0){
      map.current.flyTo({
        center: [currentFeature.longitude, currentFeature.latitude],
        zoom: 15,
      });
      const storeElement = document.getElementById(`${currentFeature.id}`);
      if (storeElement) {
        storeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest', 
          inline: 'center' 
        });
      }
    }
  }


  function createPopUp(currentFeature,isHotel=false) {
    const popUps = document.getElementsByClassName("mapboxgl-popup");
    if (popUps[0]) popUps[0].remove();
    const popup = new mapboxgl.Popup({ closeOnClick: false });
    // const popupContent = document.createElement("div");
    // const h3 = document.createElement("h3");
    // const h4 = document.createElement("h4");
  
    // h3.textContent = currentFeature.name;
    // h3.style.marginTop = "0px"
    // popupContent.style.cursor="pointer"
    // popupContent.onclick = (e) => {
    //   e.preventDefault();
    //   navigate(`/description/${currentFeature.id}?type=store`);
    // };
   
    // h4.textContent = currentFeature.address; 
  
    // popupContent.appendChild(h3); 
    // popupContent.appendChild(h4); 
    const popupContent =  createPopUpHtml(currentFeature,isHotel)
  
    popup.setLngLat([currentFeature.longitude, currentFeature.latitude])
      .setDOMContent(popupContent)
      // .setHTML(``)
      .addTo(map.current);
      // popup.removeClassName("mapboxgl-popup-content")
      // console.log(popup)
  }

  
  

  function addMarkers(data) {
    const markers = document.querySelectorAll(".mapboxgl-marker");
    markers.forEach(marker => {
      if(!hotelData.id  || marker.id != `marker-${hotelData?.id}`)
      marker.remove()
    });
    if (!data) data = stores;
    for (const marker of data) {
      if (!marker.longitude || !marker.latitude) continue;
      const el = document.createElement("img");
      el.id = `marker-${marker.id}`;
      // el.style.backgroundImage = `./assets/marker.png`
      //  el.src = `${marker?.marker_image ||'https://docs.mapbox.com/help/demos/building-a-store-locator/marker.png'})`;
      // el.src = getCustomMarker(`red`)
      el.src = marker.images && marker.images.length > 0 ? marker.images[0].image : getCustomMarker(`red`)
      el.classList = "ellipse"

      new mapboxgl.Marker(el, { offset: [0, -23] })
        .setLngLat([marker.longitude, marker.latitude])
        .addTo(map.current);

        el.addEventListener("click", (e) => {
          e?.stopPropagation()
          flyToStore(marker);
            handleLocChange(marker)
          //  createPopUp(marker);
        });
    }
  }


  return (
    <Home       floatBottonData={{
            parentCss:"absolute bottom-[35px]",
            variant:"list",
            url:updateQueryParams({
              path:"trip"
            })
          }}
           isLoading={false} showFloatButton={!selectedLocation} showOldFilter={false} showPersonalizedButton={false} showBottomNav={false} createHotelDetails={createHotelDetails} hotelData={hotelData}  nav={"Map"} setPageForLarge = {LargeScreenDiv.setPage} setPageForSmall = {smallScreenDiv.setPage} largeRef={LargeScreenDiv.scrollContainerRef} smallRef={smallScreenDiv.scrollContainerRef}
    >
{/* {
  isLoading &&  <FullScreenLoader isLoading={isLoading} />
} */}
{/* <NewFilter additionStyle={true} parentClass = {"absolute top-[50px] z-10"} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} setData={(placesResponse=[])=>{
    if(placesResponse.length>0){
      const data = []
      placesResponse.forEach((e)=>data.push(...e?.event_or_place_list))
      setStores(data)
    }
    else 
    setStores([])
}}
// isLoading={isLoading} setIsLoading={setIsLoading}
/> */}


{
   <Header  data={{
    title:"MAP",
    // buttonText:"List",
    // buttonUrl:"/?path=trip"
  }}
   url={`/planner/places-events/groups/${apiParams ? "?" + apiParams : ""}`}
  setData={(placesResponse=[])=>{
    if(placesResponse.length>0){
      const data = []
      placesResponse.forEach((e)=>data.push(...e?.event_or_place_list))
      setStores(data)
    }
    else 
    setStores([])
}}
  // setNoData={setNoData}
  // setIsLoading={setIsLoading}
  filterType="live"
  // additionStyle={true} parentClass = {"absolute top-[50px] z-10"}
  myPosition="relative"
  />
}
      <div className="wrapper map-wrapper flex flex-col lg:flex-row">
        <div
          // ref={LargeScreenDiv.scrollContainerRef}
          className="list min-w-[28vw] max-w-[30vw] border-2 max-h-screen overflow-y-scroll scroll-smooth map-left-col hidden lg:block"
        >
          { stores.length > 0? (
            stores.map((e, i) => {
              return (
                <NewStoreCard
                  key={i}
                  storeData={e}
                  flyToStore={flyToStore}
                  createPopUp={createPopUp}
                />
              );
            })
          ) : (
         <NoData height="95vh" loadingProps={{height:"0.5%"}} isInitialLoading={true} />
          )}
          {LargeScreenDiv.loading && <LoadingBar/>}
        </div>
        <div
          ref={mapContainer}
          className="map store-map border-2 md:h-[calc(100vh-182px)] h-[calc(100vh-175px)]"
        ></div>
        <div
          id="scrollDivForSmall"
          // ref={smallScreenDiv.scrollContainerRef}
          className="flex px-12 pb-4 pt-0 items-center gap-4 lg:hidden absolute bottom-[35px] w-[100vw] bg-transparent overflow-x-scroll scroll-smooth whitespace-nowrap"
        >
          {/* {stores.map((e, i) => {
            return (
              // <SingleStoreForSmallScreen
              //   key={i}
              //   storeData={e}
              //   flyToStore={flyToStore}
              //   createPopUp={createPopUp}
              // />
              <SmallPlaceOrEventCard
              key={i}
              storeData={e}
              flyToStore={flyToStore}
              createPopUp={createPopUp}
            />
           

            );
          })} */}

{
  selectedLocation && <SingleCardNew parentClassSelector="parent-map" data={selectedLocation} size={"full"} variant={"map"} boxHeight={"236px"} handleCloseLoc={handleCloseLoc} />
}

          {smallScreenDiv.loading && <div className="singleCard inline-block h-[120px] w-[200px] rounded overflow-hidden shadow-lg m-5 cursor-pointer">
            <div className="flex items-center justify-center h-[100%] bg-[#ffffff82]">
            <LoadingBar width="100%"/>
            </div>
            </div>}
        </div>
      </div>
    </Home>
  );
};

export default Store;
